import { apiFetch } from '@/lib/api/http';

/** 年間ポートフォリオ（会員1人の1年分をまとめて返す / D-113） */
export interface AnswerEntry {
  question_id: string;
  label: string;
  value: string;
}

export interface SurveyEntry {
  event_survey_id: string;
  event_id: string;
  event_title: string;
  event_type_name: string;
  survey_name: string;
  /** pre（事前課題） / post（事後） / assignment（課題） 等 */
  survey_kind: string;
  occurred_at: string;
  deadline_at: string | null;
  /** not_started（未提出） / draft（下書き） / submitted（提出済み） */
  status: string;
  submitted_at: string | null;
  answers: AnswerEntry[];
}

export interface EventEntry {
  event_id: string;
  title: string;
  type_name: string;
  starts_at: string;
  attendance_status: string | null;
  table_no: number | null;
}

export interface ScoreEntry {
  period: string;
  rank: number;
  score: number;
  /** 内訳は本人と事務局のみ。それ以外は空 */
  components: Record<string, string>;
}

export interface PresidentEntry {
  survey_type: string;
  round_name: string | null;
  answered_at: string | null;
  answers: AnswerEntry[];
}

export interface PortfolioMember {
  id: string;
  member_id: string;
  name: string;
  name_kana: string | null;
  company: string | null;
  position: string | null;
  specialty: string | null;
  cohort_name: string | null;
  course_name: string | null;
  status: string;
  photo_url: string | null;
  bio: string | null;
}

export interface Portfolio {
  fiscal_year: number;
  member: PortfolioMember;
  events: EventEntry[];
  surveys: SurveyEntry[];
  scores: ScoreEntry[];
  president: PresidentEntry[];
  /** 本編の出席率（0〜1）。対象が無ければ null */
  attendance_rate: number | null;
}

export function fetchOwnPortfolio(year?: number): Promise<Portfolio> {
  const query = year ? `?year=${year}` : '';
  return apiFetch<Portfolio>(`/portfolio/me${query}`);
}

export function fetchMemberPortfolio(memberId: string, year?: number): Promise<Portfolio> {
  const query = year ? `?year=${year}` : '';
  return apiFetch<Portfolio>(`/portfolio/${memberId}${query}`);
}
